import { Heading, HeadingProps } from "@chakra-ui/react";
import React from "react";

export function PageHeading(props: HeadingProps): React.ReactElement {
  return <Heading as="h1" size="xl" {...props} />;
}

export function SectionHeading(props: HeadingProps): React.ReactElement {
  return <Heading as="h2" size="md" {...props} />;
}

export function SubSectionHeading(props: HeadingProps): React.ReactElement {
  return <Heading as="h3" size="sm" {...props} />;
}
